import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Chart } from 'react-chartjs-2';
import type { AuditLog, ResponseListChargePointAuditLogs } from '../../../../../../../app/ApiGen';
import { DataTable, Section } from '../../../../../../../design-system';
import { sortByDate } from '../../../../../../../utils/sortBy';
import { renderAuditLogData } from '../../Logs/util';
import { AmberChartModel } from '../utils/AmberChartModel';
import type { DataPoint } from '../utils/AuditLogModel';
import { diagnosticsChartIds } from '../utils/meteringCharts';

type TableAuditLog = Pick<AuditLog, 'timestamp'>;

export const AmberTool: React.FC<{
  data: ResponseListChargePointAuditLogs['data'];
  startDate: Date;
  endDate: Date;
}> = ({ data, startDate, endDate }) => {
  const [tableExpanded, setTableExpanded] = React.useState(false);
  const chartModel = new AmberChartModel({ auditLogs: data, startDate, endDate });

  return (
    <>
      <Section style={{ height: '50vh', paddingBottom: 30 }}>
        <Chart<'bar' | 'line' | 'scatter', DataPoint[]>
          data={{ datasets: chartModel.datasets() }}
          id={diagnosticsChartIds.amber}
          options={chartModel.chartOptions()}
          type="bar"
        />
      </Section>
      <Accordion expanded={tableExpanded} onChange={() => setTableExpanded(!tableExpanded)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id="panel-header">
          <Typography>Amber audit logs</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DataTable<TableAuditLog>
            columns={[
              {
                title: 'Audit log timestamp',
                field: 'timestamp',
                customSort: sortByDate('timestamp'),
                defaultSort: 'desc',
                filtering: false,
              },
            ]}
            data={data}
            detailPanel={renderAuditLogData}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
};
